import { render, staticRenderFns } from "./BillingPlans.vue?vue&type=template&id=38cc5edc&scoped=true"
import script from "./BillingPlans.vue?vue&type=script&lang=js"
export * from "./BillingPlans.vue?vue&type=script&lang=js"
import style0 from "./BillingPlans.vue?vue&type=style&index=0&id=38cc5edc&prod&scoped=true&lang=scss"
import style1 from "./BillingPlans.vue?vue&type=style&index=1&id=38cc5edc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cc5edc",
  null
  
)

export default component.exports